// extracted by mini-css-extract-plugin
export var activityContainer = "_n5-0";
export var typingIndicatorContainer = "_n5-1";
export var typingIndicatorDot = "_n5-2";
export var wave = "_n5-3";